import "./Playlist.scss";

const Playlit = ({ title }) => {
  return (
    <div className="playlist">
      <p>{title}</p>
    </div>
  );
};

export default Playlit;
